import { methods, request } from "./base";

const razorPayApis = {
  razorpayOrderId: async (data?: any) =>
    await request({
      method: methods.POST,
      route: "/patient_plans/razorpay_order_id",
      payload: data,
    }),
};

export default razorPayApis;
